(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-corporate-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cg-corporate-slideshow')) {
  customElements.define('cg-corporate-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      const on = (node, event, fn) => node.addEventListener(event, fn, { signal: this.abort.signal });
      this.index = 0;
      this.visible = true;
      this.interval = Math.max(4000, Number(this.dataset.interval) || 6000);
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.querySelector('.cg-corporate__controls').hidden = false;
      this.dots.forEach((dot, i) => on(dot, 'click', () => this.show(i, true)));
      on(this, 'keydown', event => {
        if (!event.target.closest('.cg-corporate__controls')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      on(this, 'touchstart', event => {
        if (event.target.closest('a,button')) { this.touch = null; return; }
        this.touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      });
      on(this, 'touchend', event => {
        if (!this.touch) return;
        const dx = event.changedTouches[0].clientX - this.touch.x;
        const dy = event.changedTouches[0].clientY - this.touch.y;
        if (Math.abs(dx) > 50 && Math.abs(dy) < 80) this.show(this.index + (dx < 0 ? 1 : -1), true);
        this.touch = null;
      });
      on(document, 'visibilitychange', () => this.sync());
      on(document, 'shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index !== -1) this.show(index, true);
      });
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: .15 });
      this.observer.observe(this);
      this.preloadTimer = setTimeout(() => {
        this.slides.slice(1).forEach(slide => { const image = slide.querySelector('img'); if (image) image.loading = 'eager'; });
      }, 1200);
      this.sync();
    }
    show(index, manual = false) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        if (active) { const image = slide.querySelector('img'); if (image) image.loading = 'eager'; }
      });
      this.dataset.tone = this.slides[this.index].dataset.tone;
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      if (manual) this.querySelector('.cg-corporate__status').textContent = this.slides[this.index].getAttribute('aria-label');
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      if (this.visible && !document.hidden) {
        this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      clearTimeout(this.preloadTimer);
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
